import {store} from "../store/Store";
import {DateTime} from 'luxon';
import type {ButtonType, Order, UiOrder} from "../types";
import {OrderStatus} from "../types"
import {BigNumber} from "bignumber.js";
import {ethers} from "ethers";

const STATUS_TO_BUTTON_TYPE: Record<OrderStatus, ButtonType> = {
    'SETTLED': 'primary',
    'PENDING': 'warning',
    'PENDING_CANCEL': 'warning',
    'PENDING_SETTLE': 'warning',
    'CANCELLED': 'danger',
    'FAILED' : 'danger',
    'REFUNDED' : 'info'
};

const STATUS_MAP = {
    'FAILED': 'REFUND',
    'PENDING_SETTLE': 'PENDING SETTLE',
    'PENDING_CANCEL': 'PENDING CANCEL'
};

export function sortByTimestamp(a: any, b: any)
{
    return ethers.BigNumber.from(a.timestamp).sub(ethers.BigNumber.from(b.timestamp)).toNumber();
}

export function filterOrderSourceByDtw(isDtw: boolean) {
    return function(order: any) {
        if (isDtw === undefined)
        {
            return true;
        }
        const orderSource = order.chainOrderSource;

        return isDtw == orderSource.orderSource.endsWith("_DTW");
    }
}

export function filterByOrderSource()
{
    return function (order: any)
    {
        const chainOrderSource = order.chainOrderSource;

        let dtwOrderSource = store.chainToUse.substring(0, 3) + "_DTW";
        return (chainOrderSource.orderSource == store.chainToUse || chainOrderSource.orderSource == dtwOrderSource)
    }
}

export function formatOrderForUi(order: Order, index: number): UiOrder
{
    return {
        positionIndex: index + 1,
        date: DateTime.fromMillis(order.timestamp).toLocaleString(DateTime.DATETIME_MED),
        buttonType: STATUS_TO_BUTTON_TYPE[order.status],
        statusMessage: mapStatus(order.status),
        limit: parseLimit(order.limitAmount, order.sellingAsset),
        sold: parseAndScaleQuantity(order.quantitySold, order.sellingAsset),
        received: order.status == 'FAILED' || order.status == 'CANCELLED' || order.status == "REFUNDED" ? '-' : order.status == 'PENDING' ? 'PENDING' : parseAndScaleQuantity(order.quantityBought,
            order.buyingAsset),
        soldSymbol: order.sellingAsset.toUpperCase(),
        boughtSymbol: order.buyingAsset.toUpperCase(),
        full_tx_id: order.placeTransactionId,
        place_tx: truncateTxID(order.placeTransactionId, 10),
        place_tx_href: store.ethscanPrefix + order.placeTransactionId,
        settle_tx: order.settleTransactionId ? truncateTxID(order.settleTransactionId, 10) : undefined,
        settle_tx_href: order.settleTransactionId ? store.ethscanPrefix + order.settleTransactionId : undefined,
        tx_href: order.refundTransactionId ? store.ethscanPrefix + order.refundTransactionId : order.settleTransactionId ? store.ethscanPrefix + order.settleTransactionId : order.placeTransactionId,
        refundable: order.refundable,
        feePaid: parseLimit(order.feePaid, order.sellingAsset),
        quantityObtained: order.status == 'FAILED' || order.status == 'CANCELLED' || order.status == "REFUNDED" ? '' : order.status == 'PENDING' ? 'PENDING' :order.quantityBought.toString(),
        status: order.status
    }
}
function parseAndScaleQuantity(quantity: BigNumber, symbol: string)
{
    return quantity.toFixed(getDpForToken(symbol), BigNumber.ROUND_FLOOR);
}

function getDpForToken(token)
{
    const defaultDp: number = 5;
    if (token in store.tokenDPs)
    {
        return BigNumber.min(store.tokenDPs[token], defaultDp).toNumber();
    }
    else
    {
        return defaultDp;
    }
}

function mapStatus(status: string)
{
    if (status in STATUS_MAP)
    {
        return STATUS_MAP[status];
    }
    else
    {
        return status;
    }
}

function parseLimit(limit: BigNumber, symbol: any)
{
    try{
        if (limit.eq(new BigNumber(0)))
        {
            return '-';
        }
        else
        {
            return parseAndScaleQuantity(limit, symbol);
        }
    }
    catch (e)
    {
        return '-';
    }
}

function truncateTxID(txID: string, len: number)
{
    const halfwayPoint: number = Math.floor(len / 2);
    return txID.slice(0, halfwayPoint) + '...' + txID.slice(-halfwayPoint);
}